export function PlusIcon({ className }: { className?: string }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="12" y="7" width="12" height="2" transform="rotate(-180 12 7)" fill="#F7941D"/>
      <rect x="5" y="12" width="12" height="2" transform="rotate(-90 5 12)" fill="#F7941D"/>
    </svg>
  );
}
